<template>
  <el-dialog
    class="card-dialog"
    v-loading="loading"
    fullscreen
    :visible.sync="dialogVisible"
    append-to-body
    destroy-on-close
    :show-close="false"
  >
    <my-page-layout>
      <card-list
        v-if="!showDetail"
        v-model="selected"
        :data="data"
        :cancel="onCancel"
        is-dialog
        :submit="onSubmit"
        @to-detail="toDetail"
      />
      <payment-information-form
        v-else
        :id="initCardSeq"
        @submit-new="backToListFromNew"
        @submit-edit="backToListFromEdit"
        @cancel="backToList"
      />
    </my-page-layout>
    <prompt-dialog
      :visible.sync="promptNewCard"
      :title="$t('ec-line012.newCardTitle')"
      @on-cancel="onCancelPromptNewCard"
    >
      <template #content>
        <div class="mt-10 mb-10">
          <p class="whitespace-pre-line text-base">
            {{ $t('ec-line012.newCardContent1') }}
          </p>
          <p class="whitespace-pre-line text-base text-red-150">
            {{ $t('ec-line012.newCardContent2') }}
          </p>
        </div>
      </template>
    </prompt-dialog>
  </el-dialog>
</template>

<script>
import MyPageLayout from '@/layouts/MyPageLayout.vue'
import CardList from '@/components/ec-line012/CardList.vue'
import PromptDialog from '@/components/PromptDialog.vue'
import PaymentInformationForm from '@/components/ec-line013/PaymentInformationForm.vue'

export default {
  components: { MyPageLayout, CardList, PromptDialog, PaymentInformationForm },
  props: {
    visible: Boolean,
    data: {
      type: Array,
      required: false,
      default: () => [],
    },
    value: {
      type: [String, Number],
      required: false,
      default: () => '',
    },
    loading: Boolean,
  },
  data() {
    return {
      selected: this.value,
      initCardSeq: '',
      cardSeq: '',
      showDetail: false,
      promptNewCard: false,
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(value) {
        this.$emit('update:visible', value)
      },
    },
  },
  watch: {
    value(val) {
      this.selected = val
    },
  },
  methods: {
    onCancel() {
      // Reset to default
      this.selected = this.value
      this.dialogVisible = false
      this.cardSeq && this.cardSeq === this.value && this.$emit('change', this.Constants.PAYMENT_DIALOG_TYPE.EDIT_CARD)
    },
    onCancelPromptNewCard() {
      this.promptNewCard = false
    },
    onSubmit(selected) {
      this.selected = selected
      this.$emit('input', this.selected)

      if (this.cardSeq && this.cardSeq === this.value && selected === this.value) {
        this.$emit('change', this.Constants.PAYMENT_DIALOG_TYPE.EDIT_CARD)
      } else if (selected !== this.value) {
        this.$emit('change', this.Constants.PAYMENT_DIALOG_TYPE.CHANGE_CARD)
      }

      this.cardSeq = ''
      this.dialogVisible = false
    },
    toDetail(id = '') {
      this.initCardSeq = id
      this.showDetail = true
    },
    backToListFromNew(cardSeq) {
      this.initCardSeq = ''
      this.cardSeq = cardSeq
      this.$emit('reload-list')
      this.selected = cardSeq
      this.promptNewCard = true
      this.showDetail = false
    },
    backToListFromEdit(cardSeq) {
      this.$alert({
        message: this.$t('ec-line013.content.updateCardSuccess'),
        type: 'success',
      })
      this.initCardSeq = ''
      this.cardSeq = cardSeq
      this.$emit('reload-list')
      this.showDetail = false
    },
    backToList(cardSeq) {
      this.initCardSeq = ''
      this.cardSeq = cardSeq
      this.$emit('reload-list')
      this.showDetail = false
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/css/components/card-dialog.scss';
</style>
